import { createContext, useContext, useEffect, useState } from "react";
import translations, { LANGUAGE_CODES, RTL_LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [langName, setLangName] = useState("ENGLISH");
  const langCode = LANGUAGE_CODES[langName] ?? "EN";
  const dict = translations[langCode] ?? translations.EN;

  useEffect(() => {
    document.documentElement.dir = RTL_LANGUAGES.has(langCode) ? "rtl" : "ltr";
    document.documentElement.lang = langCode.toLowerCase();
  }, [langCode]);

  function t(key) {
    return dict[key] ?? translations.EN[key] ?? key;
  }

  return (
    <LanguageContext.Provider value={{ langName, setLangName, langCode, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
